function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10,23.1c0,0,0-1.3-0.1-2.4c-0.1-0.7-0.3-1.4-0.3-1.4s1.3-0.8,2.5-1.7c1.3-0.9,2.4-2,2.4-2s0.7,1.9-0.2,3.3 C13,21,10,23.1,10,23.1z M7.3,17.6c1.7-1.6,3-2.9,3.4-3.3c1.5-1.5,1.5-1.9,1.2-2.1c-0.2-0.2-0.6-0.3-2.1,1.3 c-0.4,0.4-1.7,1.7-3.3,3.4c-0.7-0.7-1.4-1.4-1.6-1.6c6-10.1,13.2-13.3,16-11.9c1,3.3-1.7,9.5-12,15.9C8.3,18.7,7.8,18.2,7.3,17.6z  M4.8,14.4c0,0-0.7-0.2-1.4-0.3C2.3,14,1,14,1,14s2-3,4.2-4.3c1.5-0.9,3.3-0.2,3.3-0.2s-1.1,1.2-2,2.4C5.6,13.2,4.8,14.4,4.8,14.4z  M11.5,12.6c0.1,0.1-1.1,1.6-2.8,3.3s-3.2,2.9-3.3,2.8c-0.1-0.1,1.1-1.6,2.8-3.3S11.4,12.4,11.5,12.6z"
});

function SvgJoinMeeting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinMeeting);
export default __webpack_public_path__ + "static/media/JoinMeeting.39f8f333.svg";
export { ForwardRef as ReactComponent };